import React from 'react'
import type { ParentProps } from 'types/explorer'
import TrackVersionsContainer from 'components/nesting/track-versions-container'
import ExplorerTrackVersions from './ExplorerTrackVersions'

const ExplorerTrackVersionsContainer = ({
  parentProps,
  currentTrackIndex,
}: {
  parentProps: ParentProps
  currentTrackIndex?: number
}): React.ReactNode => {
  return (
    <TrackVersionsContainer
      parentProps={parentProps}
      component={ExplorerTrackVersions}
      currentTrackIndex={currentTrackIndex}
    />
  )
}

export default ExplorerTrackVersionsContainer
